import React, { useCallback, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Header } from "../../ui/Header";
import { Menu } from "../../ui/Menu";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import download_icon from "../../../assets/images/download-icon_2.svg";
import file_download from "../../../assets/images/download-pdf-icon.svg";
import { MiniLoader } from "../../ui/MiniLoader";
import { ValidateToken } from "../../../helpers/validateToken";
import { toast } from "react-toastify";
import axiosApi from "../../../axios/axios-api";
import { LogoPetroprix } from "../../ui/LogoPetroprix";

const URL_GET_PLANTILLA = "flotas/descargarPlantilla";
const URL_POST_VALIDATE_PLANTILLA = "flotas/validarDatosPlantilla";

export const InformationFileScreen = () => {
  const { nombre, apellido, flotaActiva, token } = useSelector(
    (state) => state.auth
  );
  const [loadingPlantilla, setLoadingPlantilla] = useState(false);
  const [fileToUpload, setFileToUpload] = useState({ base64: "", name: "" });
  const [validatingFile, setValidatingFile] = useState(false);
  const [uploadedVehicles, setUploadedVehicles] = useState([]);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const downloadPlantilla = useCallback(async () => {
    setLoadingPlantilla(true);
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(`${URL_GET_PLANTILLA}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 200) {
          let { plantilla } = response.data.data;

          // Decode the Base64 string
          const binaryString = window.atob(plantilla);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Create a Blob from the byte array
          const blob = new Blob([bytes], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create a link element
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "plantilla_subida_vehículos.xlsx"; // Set the desired file name
          document.body.appendChild(link);
          link.click(); // Trigger the download
          document.body.removeChild(link); // Clean up

          setLoadingPlantilla(false);
        } else {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
          setLoadingPlantilla(false);
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      toast(
        t("flotas.importar-vehiculos.informacion.error.download-plantilla"),
        {
          icon: <LogoPetroprix />,
        }
      );
      setLoadingPlantilla(false);
    }
  }, []);

  const uploadPlantilla = (event) => {
    const file = event.target.files[0];

    if (
      file &&
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      const reader = new FileReader();

      // Read the file as a data URL
      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = reader.result.split(",")[1]; // Get the Base64 part
        setFileToUpload({ base64: base64, name: file.name });
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } else {
      toast(t("flotas.importar-vehiculos.informacion.error.upload-plantilla"), {
        icon: <LogoPetroprix />,
      });
    }
  };

  const handleUploadFile = async () => {
    setValidatingFile(true);

    const data = {
      idCcp: flotaActiva?.id_cuenta,
      plantilla: fileToUpload.base64,
    };

    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.post(
          `${URL_POST_VALIDATE_PLANTILLA}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response?.data?.code === 200) {
          setValidatingFile(false);
          if (response?.data?.data?.length > 0) {
            setUploadedVehicles(response?.data?.data);
            navigate("confirmar", {
              state: {
                uploadedVehicles: response.data.data,
              },
            });
          } else {
            setUploadedVehicles([]);
            toast(t("flotas.importar-vehiculos.alert-empty"), {
              icon: <LogoPetroprix />,
            });
          }
          setFileToUpload({ base64: "", name: "" });
        } else {
          setValidatingFile(false);
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      setValidatingFile(false);
      toast(t("flotas.importar-vehiculos.informacion.error.upload-plantilla"), {
        icon: <LogoPetroprix />,
      });
    }
  };

  return (
    <>
      <Menu />
      <Container className="content-page">
        <Header name={nombre + " " + apellido} />
        <Container>
          <Row className="page-header pb-4">
            <Col sm={12}>
              <h1>
                <Link to={`/flotas/mis-flotas`} className="no-decoration">
                  &lt;
                  {t("flotas.importar-vehiculos.header.h1")}
                </Link>
              </h1>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="content-section">
            <>
              <Col sm={12} lg={5}>
                <Row>
                  <Container className="px-4">
                    <div>
                      <p>
                        {t(
                          "flotas.importar-vehiculos.informacion.p-agregar-xslx-1"
                        )}
                      </p>
                      <p>
                        {t(
                          "flotas.importar-vehiculos.informacion.p-agregar-xslx-2"
                        )}
                      </p>
                      <p>
                        {t(
                          "flotas.importar-vehiculos.informacion.p-agregar-xslx-3"
                        )}
                      </p>

                      <ul>
                        <li>
                          <span className="bold-text">
                            {t(
                              "flotas.importar-vehiculos.informacion.p-agregar-xslx-4"
                            )}
                          </span>
                        </li>
                        <li>
                          <span className="bold-text">
                            {t(
                              "flotas.importar-vehiculos.informacion.p-agregar-xslx-5"
                            )}
                          </span>
                        </li>
                      </ul>
                      <p>
                        {t(
                          "flotas.importar-vehiculos.informacion.p-agregar-xslx-6"
                        )}
                      </p>
                    </div>
                  </Container>
                </Row>
              </Col>
              <Col sm={12} lg={7}>
                <Container>
                  <Row>
                    <Container className="px-4">
                      <div className="bold-text">
                        {t("flotas.importar-vehiculos.informacion.p-paso-1")}
                      </div>
                      <div>
                        {t("flotas.importar-vehiculos.informacion.p-descarga")}
                      </div>
                      <Button
                        variant="primary"
                        className="flotas-btn-add me-3 mt-2"
                        onClick={downloadPlantilla}
                        disabled={loadingPlantilla}
                      >
                        {loadingPlantilla ? (
                          <>
                            <MiniLoader />
                            <span style={{ color: "#db0b27" }} className="p-1">
                              {t(
                                "flotas.importar-vehiculos.informacion.downloading-template-btn"
                              )}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="p-1">
                              <img
                                className=""
                                src={download_icon}
                                alt="download"
                                width={18}
                                height={18}
                              />
                            </span>
                            {t(
                              "flotas.importar-vehiculos.informacion.download-template-btn"
                            )}
                          </>
                        )}
                      </Button>
                    </Container>
                  </Row>
                  <Row>
                    <Container
                      className="py-3 m-3"
                      style={{
                        backgroundColor: "#ffff",
                        borderRadius: "10px",
                      }}
                    >
                      <div className="bold-text">
                        {t("flotas.importar-vehiculos.informacion.p-paso-2")}
                      </div>
                      <div>
                        {t(
                          "flotas.importar-vehiculos.informacion.p-subir-archivo"
                        )}
                      </div>
                      <br></br>
                      <div className="annotation">
                        {t(
                          "flotas.importar-vehiculos.informacion.p-aclaracion"
                        )}
                      </div>
                      <div className="annotation">
                        {t(
                          "flotas.importar-vehiculos.informacion.p-aclaracion-2"
                        )}
                      </div>
                      <Row>
                        <Button
                          variant="outline-grey"
                          id="nombre-fichero"
                          onClick={() => {}}
                          className={"btn-outline-grey mt-2 m-2 mb-2"}
                          style={{ width: "300px" }}
                          disabled={true}
                        >
                          {fileToUpload.name}
                        </Button>
                        <label
                          htmlFor="upload-document"
                          variant="outline-primary"
                          className="m-2 py-2 btn btn-outline-primary btn-no-border btn-sm"
                          style={{ width: "220px" }}
                        >
                          <img src={file_download} alt="" />{" "}
                          {t("flotas.table.seleccionar-archivo")}
                        </label>
                        <input
                          type="file"
                          name="document"
                          id="upload-document"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          onChange={uploadPlantilla}
                        />
                      </Row>

                      <Button
                        variant={"outline-primary"}
                        className="flotas-btn-add me-3 mt-2"
                        disabled={fileToUpload.name.length === 0 ? true : false}
                        onClick={handleUploadFile}
                        style={
                          validatingFile
                            ? {
                                pointerEvents: "none",
                                backgroundColor: "white",
                              }
                            : {}
                        }
                      >
                        {validatingFile ? (
                          <>
                            <MiniLoader size="xs" />
                            <span style={{ color: "#db0b27" }} className="p-1">
                              {t(
                                "flotas.registro-flota.informacion.btn-next.validating"
                              )}
                            </span>
                          </>
                        ) : (
                          t("flotas.registro-flota.informacion.btn-next")
                        )}
                      </Button>
                    </Container>
                  </Row>
                </Container>
              </Col>
            </>
          </Row>
        </Container>
      </Container>
    </>
  );
};
